export default {
	API_INVENTORY: process.env.REACT_APP_API_INVENTORY,
	API_ACCOUNT: process.env.REACT_APP_API_ACCOUNT,
	API_VIEWER: process.env.REACT_APP_API_VIEWER,
	SENTRY_ENABLE: process.env.REACT_APP_SENTRY_ENABLE === 'true',
	SENTRY_DEBUG: process.env.REACT_APP_SENTRY_DEBUG === 'true',
	SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
	SENTRY_ENVIRONMENT: process.env.REACT_APP_SENTRY_ENVIRONMENT,
};
